import { Grid2 as Grid } from '@mui/material';
import { Dropdown, TextArea, TextInput } from 'framework/form';
import { SEVERITY_OPTIONS } from '../constants';

const IncidentForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextInput source="shortDescription" label="Short description" />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Dropdown source="severity" label="Severity" options={SEVERITY_OPTIONS} placeholder="Select" />
      </Grid>
      <Grid size={6}>
        <TextInput source="linkToDetails" label="Link to details" />
      </Grid>
      <Grid size={12}>
        <TextArea source="notes" label="Notes" rows={4} />
      </Grid>
    </Grid>
  );
};

export default IncidentForm;
